import Grid from "@mui/material/Grid2";
import React from "react";
import useDebugInformation from "../../../../../../../../../hooks/useDebugInformation";
import { useAppSelector } from "@store/hooks";
import { MemoizedDropdownInput } from "./helpers";
import { Notes } from "./Notes";
import { MemoizedInputForCarePlan } from "../../../../../../../../Shared/MemoizedInputForCarePlan";

const name = "PropertyTab"
const notRequired = ["CarePlanPlanDetailsPropertyGasSafetyDueDate"]

type Props = {
    parent: string
}


/**
 * Component for handling property-related details in a Service Agreement Policy.
 *
 * @param {Object} props - Component props.
 * @param {string} props.parent - The parent component's name for debugging purposes.
 * @returns {JSX.Element} - The rendered PropertyTab component.
 */
const PropertyTab: React.FC<Props> = ({ parent }) => {
    // Various states and hooks used in the component.
    const serviceAgreementPolicyExclusionDetails = useAppSelector(({ ui }) => ui.CarePlanPlanDetailsPropertyExclusionDetails);
    const serviceAgreementPolicyIsLandlord = useAppSelector(({ ui }) => ui.CarePlanPlanDetailsIsLandlord);
    const prefix = "CarePlanPlanDetailsProperty";

    const debugName = `${parent}▷[${name}]`;
    useDebugInformation(debugName, { prefix, parent, serviceAgreementPolicyExclusionDetails, serviceAgreementPolicyIsLandlord });

    return (
        (< Grid container spacing={1} >
            <MemoizedDropdownInput inputName="BuildingTypes" tabName={name} parent={debugName} prefix={prefix} xs={12} sm={6} />
            <MemoizedInputForCarePlan inputName={`${prefix}Bathrooms`} tabName={name} parent={debugName} prefix={prefix} xs={12} sm={6} type="number" />
            <MemoizedInputForCarePlan inputName={`${prefix}Bedrooms`} tabName={name} parent={debugName} prefix={prefix} xs={12} sm={6} type="number" />
            <MemoizedInputForCarePlan inputName={`${prefix}ExternalDoors`} tabName={name} parent={debugName} prefix={prefix} xs={12} sm={6} type="number" />
            <MemoizedInputForCarePlan inputName={`${prefix}GasAppliances`} tabName={name} parent={debugName} prefix={prefix} xs={12} sm={serviceAgreementPolicyIsLandlord ? 3 : 6} type="number" />
            <MemoizedInputForCarePlan inputName={`${prefix}Radiators`} tabName={name} parent={debugName} prefix={prefix} xs={12} sm={serviceAgreementPolicyIsLandlord ? 3 : 6} type="number" />
            {serviceAgreementPolicyIsLandlord && <MemoizedInputForCarePlan inputName={`${prefix}GasSafetyDueDate`} tabName={name} parent={debugName} prefix={prefix} xs={12} sm={6} type="date" notRequired={notRequired} />}
            <Grid
                size={{
                    xs: 12,
                    sm: 12
                }}>
                <Notes note={serviceAgreementPolicyExclusionDetails} name={`${prefix}ExclusionDetails`} />
            </Grid>
        </Grid >)
    );
}

export default React.memo(PropertyTab)